import React, { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { Flex, Icon, Text } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

const Message = styled(Text)`
  font-family: ${themeGet('headerFontFamily')};
`;

const MissingImage = (props: ComponentProps<typeof Flex>) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bg="background.page"
      height="200px"
      p="3"
      {...props}
    >
      <Icon mb="2" size="2.5rem" color="icon.inclusion" name="stay" />
      <Message
        textAlign="center"
        fontWeight="bold"
        fontSize="xs"
        lineHeight="18px"
      >
        Sorry, we can&apos;t find any images
      </Message>
    </Flex>
  );
};

export default MissingImage;
